









































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ONE_DAY_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import PatientWithActigraphyChart from '@/components/patient-stats/graphs/actigraphy-reports/PatientWithActigraphyChart.vue'
import { GetterNames as PatientGetterName } from '@/store/modules/patient/keys'
import { getStartOfDay } from '@/utils/time'
import { ActionNames } from '@/store/modules/patient-with-actigraphy-reports/keys'
import { flattenJsonApiResponse } from '@/store/utils/converter'
import { FlatPatientWithActigraphyReports } from '@/store/modules/patient-with-actigraphy-reports/getters'

type ActigraphyReportsWithPeriod = {
  activityReport: FlatPatientWithActigraphyReports
  startTime: number
  endTime: number
}
export default Vue.extend({
  components: {
    PatientWithActigraphyChart,
  },
  inheritAttrs: false,
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    displayWeeks: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isInitialized: false as boolean,
      loopbackWeeks: 0 as number, // FIXME use 0 as a initial value
      actigraphyReportsWithPeriod: [] as ActigraphyReportsWithPeriod[],
      loading: true,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, [PatientGetterName.patientById]),
    patientId(): string {
      return this.$route.params.patient_id || ''
    },
    timezone(): string {
      return this[PatientGetterName.patientById](this.patientId).timezone
    },
    endTimestampForActigraphy(): number {
      const adjustedTime = getStartOfDay({
        timezone: this.timezone,
        baseHour: 12,
        timestamp: new Date().getTime(),
        // FIXME: Eventually, should use time selector's time.
        // Time selector is using end of today, but it causes problem when creates12 - 12 period data
      })
      return adjustedTime + ONE_DAY_TIMESTAMP - ONE_DAY_TIMESTAMP * 7 * (this.loopbackWeeks - 1)
    },
    startTimestampForActigraphy(): number {
      return this.endTimestampForActigraphy - ONE_DAY_TIMESTAMP * 7
    },
    limitTimestamp(): number {
      return getStartOfDay({
        timezone: this.timezone,
        baseHour: 12,
        timestamp: this.startTimestamp,
      })
    },
    cannotLoadMore(): boolean {
      return this.limitTimestamp >= this.endTimestampForActigraphy - ONE_DAY_TIMESTAMP - ONE_DAY_TIMESTAMP * 7
    },
  },
  watch: {
    async startTimestamp(n, o): Promise<void> {
      this.loopbackWeeks = 0
      this.actigraphyReportsWithPeriod = []
      this.fetchNextPeriod()
    },
    async endTimestamp(n, o): Promise<void> {
      this.loopbackWeeks = 0
      this.actigraphyReportsWithPeriod = []
      this.fetchNextPeriod()
    },
  },
  async mounted(): Promise<void> {
    this.fetchNextPeriod()
  },
  methods: {
    ...mapActions(ModuleNames.patientWithActigraphyReports, [ActionNames.getPatientWithActigraphyReportsById]),
    async fetchPatientWithActigraphy(options: {
      startTimestamp: number
      endTimestamp: number
    }): Promise<FlatPatientWithActigraphyReports> {
      const actigraphyReport = await this[ActionNames.getPatientWithActigraphyReportsById]({
        patientId: this.patientId,
        ...options,
      })
      return flattenJsonApiResponse(actigraphyReport)
    },
    async fetchNextPeriod(): Promise<void> {
      this.loading = true
      const nexPeriod = this.getNexPeriod()
      if (nexPeriod) {
        const actigraphyReport = await this.fetchPatientWithActigraphy({
          startTimestamp: nexPeriod.startTimestamp,
          endTimestamp: nexPeriod.endTimestamp,
        })
        this.actigraphyReportsWithPeriod.unshift({
          startTimestamp: nexPeriod.startTimestamp,
          endTimestamp: nexPeriod.endTimestamp,
          actigraphyReport,
        })
      }
      this.loading = false
    },
    getNexPeriod(): { startTimestamp: number; endTimestamp: number } {
      this.loopbackWeeks += 1
      if (
        this.startTimestamp > this.startTimestampForActigraphy &&
        this.startTimestamp > this.endTimestampForActigraphy
      ) {
        return null
      }

      return {
        startTimestamp: this.startTimestampForActigraphy,
        endTimestamp: this.endTimestampForActigraphy,
      }
    },
  },
})
